module.exports = __webpack_public_path__ + "img/digital-mobile.fdb68f6e.png";